import { FirebaseDocRefType } from 'firebase/index'
import { BreadType } from 'types/bread'

const fetchBreadByRef = (breadRef: FirebaseDocRefType): Promise<BreadType | undefined> => {
  return breadRef
    .get()
    .then((snapshot) => {
      const data = snapshot.data() as BreadType
      if (!data) return undefined
      data.bread_ref = snapshot.ref
      return data
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export default fetchBreadByRef
